<script setup>
import BaseTooltip from "./BaseTooltip.vue";
import SvgIcon from "./SvgIcon.vue";

defineProps({
  text: { type: String, default: undefined },
  ariaLabel: { type: String, default: "More information" },
  position: { type: String, default: "top" },
  // When provided, renders a hidden mirror of the description with this id
  // so a form control elsewhere can reference it via `aria-describedby`. The
  // wrapping base components (BaseCheckbox, BaseInput, …) generate this id and
  // pass it through their `label-info` scoped slot.
  id: { type: String, default: undefined },
});
</script>

<template>
  <BaseTooltip open-on-click :position :text>
    <button type="button" class="info-trigger" :aria-label>
      <SvgIcon name="message/info" />
    </button>
    <template v-if="$slots.default" #content>
      <div class="info-tooltip-content"><slot /></div>
    </template>
  </BaseTooltip>
  <span v-if="id" :id hidden>
    <slot v-if="$slots.default" />
    <template v-else>{{ text }}</template>
  </span>
</template>

<style lang="scss" scoped>
@use "@/colors" as c;

.info-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: c.$text-subtle;
  line-height: 0;

  :deep(svg) {
    width: 14px;
    height: 14px;
  }

  &:hover,
  &:focus-visible {
    color: c.$text;
  }

  &:focus-visible {
    outline: 2px solid c.$main;
    outline-offset: 2px;
    border-radius: 50%;
  }
}

.info-tooltip-content :deep(p + p) {
  margin-top: 8px;
}
</style>
